/* eslint-disable */


/**
 * Create styles for `<KeyValueDateTimeField />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<KeyValueDateTimeField />` styles
 */
const keyValueDateTimeFieldStyles = ({ theme }) => ({});

export default keyValueDateTimeFieldStyles;
